import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export const DATE_FORMAT = 'DD.MM.YYYY';

export function stringToDayjs(value?: string): Dayjs | null {
  if (!value) return null;

  const parsed = dayjs(value, DATE_FORMAT, true);
  return parsed.isValid() ? parsed : null;
}

export function dayjsToString(value: Dayjs | null): string {
  return value ? value.format(DATE_FORMAT) : '';
}
